import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGoComponent } from './simple-icons-go.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGoComponent ],
    exports:      [ SimpleIconsGoComponent ],
    bootstrap:    []
})
export class SimpleIconsGoModule {}
